<template>
  <connexion-container session-type="user" :no-client="true">
    <h1 class="d-none">Inscrivez-vous</h1>
    <form class="access-form__form" @submit.prevent>
      <wizard @cancel="cancel" @submit="submit" :loading="loading" ref="signUpForm">
        <wizard-step title="Infos">
          <div class="form-row">
            <r-input v-model="params.last_name" name="nom" label="Nom" icon="user" class="col" :error="errors.last_name" />
            <r-input v-model="params.first_name" name="prénom" label="Prénom" icon="user-o" class="col" :error="errors.first_name" />
          </div>
          <r-input v-model="params.email" name="email" label="Email" icon="envelope-o" placeholder="Votre e-mail" type="email" :error="errors.email" />
          <p-input v-model="params.phone" />
          <r-input v-model="params.password"
            vid="pConf"
            name="mot de passe"
            label="Mot de passe"
            icon="key"
            :type="password"
            placeholder="Min. 8 caractères"
            :rules="'min:8'"
            :error="errors.password">
            <i class="has-icon-right__icon fa fa-eye" @click.prevent="switchType('password')"></i>
          </r-input>
          <r-input v-model="params.password_confirmation"
            name="confirmation du mot de passe"
            label="Confirmer le mot de passe"
            icon="key"
            :type="passwordConfirmation"
            placeholder="Min. 8 caractères"
            :rules="'min:8|password:pConf'"
            :error="errors.password_confirmation">
            <i class="has-icon-right__icon fa fa-eye" @click.prevent="switchType('passwordConfirmation')"></i>
          </r-input>
        </wizard-step>
        <wizard-step title="Mon entreprise">
          <r-input
            v-model="center.name"
            label="Raison sociale"
            icon="building-o"
            placeholder="Nom de l'entreprise"
            name="nom de l'entreprise"
            :error="errors['intervention_center.name']" />
          <r-input v-model="center.vat_number" label="N° de TVA" icon="building" :required="false" />
          <r-input
            v-model="center.address"
            label="Adresse"
            icon="address-card-o"
            name="adresse de l'entreprise"
            :error="errors['intervention_center.address']" />
          <div class="form-row">
            <zc-input v-model="center.zip_code" class="col" :error="errors['intervention_center.zip_code']" />
            <r-input
              v-model="center.city"
              label="Ville"
              icon="map-o"
              class="col"
              name="ville de l'entreprise"
              :error="errors['intervention_center.city']" />
          </div>
          <r-input
            v-model="center.phone"
            name="téléphone"
            label="Téléphone"
            icon="phone"
            type="tel"
            :rules="{ regex: $regexPhone }"
            :error="errors['intervention_center.phone']" />
        </wizard-step>
        <wizard-step title="Formation" v-if="trainingSessions.length">
          <vv-provider tag="div" class="form-group mb-0" rules="required" v-slot="{ errors, classes }" name="formation">
            <label for="coursesList" class="access-form__label">
              Choisir une session de formation
              <abbr title="Ce champ est obligatoire">*</abbr>
            </label>
            <p class="alert alert-secondary">Vous devez effectuer la formation pour devenir Centre d'intervention agréé et accéder à votre espace dédié.</p>
            <v-select
              :options="trainingSessions"
              label="name"
              v-model="selectedTraining"
              :searchable="false"
              :class="{ 'is-error': classes.invalid }">
              <span slot="no-options">Aucune formation proposée pour le moment.</span>
            </v-select>
            <p class="mb-0">
              <small class="text-danger">{{ errors[0] }}</small>
            </p>
          </vv-provider>
          <div class="access-form__modal clearfix" v-if="selectedTraining">
            <button type="button" class="btn btn-link float-right pr-0" data-toggle="modal" data-target="#courseDescrModal">Découvrir la formation</button>
            <div id="courseDescrModal" class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="courseModalLabel" aria-hidden="true">
              <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title my-auto" id="courseModalLabel">{{ selectedTraining.name }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <div v-html="selectedTraining.description"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </wizard-step>
        <wizard-step title="Message" v-else>
          <vv-provider tag="div" class="form-group mb-0" rules="required" v-slot="{ errors, classes }" name="message">
            <label class="access-form__label">
              Message
              <abbr title="Ce champ est obligatoire">*</abbr>
            </label>
            <div class="input-group has-icon-left">
              <textarea v-model="params.message"
                placeholder="Demande de contact"
                class="access-form__textarea form-control"
                :class="{ 'is-invalid': errors.message || classes.invalid }"  />
              <i class="has-icon-left__icon fa fa-comment-o" aria-hidden="true"></i>
            </div>
            <p class="mb-0">
              <small class="text-danger">{{ errors[0] }}</small>
            </p>
          </vv-provider>
          <small class="text-danger">{{ errors.message }}</small>
        </wizard-step>

      </wizard>
    </form>
  </connexion-container>
</template>

<script>
import ConnexionContainer from '@/components/layout/ConnexionContainer'

export default {
  name: 'SignUp',
  components: {
    ConnexionContainer
  },
  data () {
    return {
      loading: false,
      params: {},
      center: {},
      password: 'password',
      passwordConfirmation: 'password',
      errors: {},
      trainingSessions: [],
      selectedTraining: null
    }
  },
  computed: {
    moveToError () {
      let first = ['first_name', 'last_name', 'email', 'password', 'password_confirmation']
      let second = [
        'intervention_center.name',
        'intervention_center.address',
        'intervention_center.zip_code',
        'intervention_center.city',
        'intervention_center.phone'
      ]
      if (_.intersection(_.keys(this.errors), first).length) return 0
      if (_.intersection(_.keys(this.errors), second).length) return 1
      else return 2
    }
  },
  async mounted () {
    await this.fetchTrainingSessions()
  },
  methods: {
    fetchTrainingSessions () {
      this.$http.get('/training_sessions').then(resp => {
        this.trainingSessions = resp.data
      })
    },
    cancel () {
      this.$router.push('sign_in')
    },
    switchType (type) {
      this[type] = this[type] === 'password' ? 'text' : 'password'
    },
    submit () {
      this.loading = true
      let params = {
        ...this.params,
        registered_for: this.$appName,
        intervention_center_attributes: this.center
      }
      if (this.selectedTraining) {
        params = {
          ...params,
          training_session_id: this.selectedTraining.id
        }
      }
      this.$http.post('/user_auth', params).then(resp => {
        let withTrainings = this.trainingSessions.length > 0
        this.$router.push({ name: 'userSignIn', params: { successSignUp: true, withTrainings: withTrainings } })
      }).catch(err => {
        this.loading = false
        this.errors = {}
        console.log(err)
        if (err.response.status === 422) {
          let e = err.response.data.errors
          this.errors = _.reduce(e, (result, value, key) => {
            result[key] = value[0]
            return result
          }, {})
          this.$refs.signUpForm.move(this.moveToError)
        }
      })
    }
  }
}
</script>
